export default __webpack_public_path__ + "static/media/cargo-prohibited.0d25617c.png";